exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".music[data-v-6a49d3b2]{position:fixed;right:30px;top:11px;opacity:.9;z-index:20}audio[data-v-6a49d3b2]{margin:0;padding:0}.music i[data-v-6a49d3b2]{font-size:30px;color:hsla(39,68%,73%,.96);transform:scale(.8);z-index:999}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6a49d3b2","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Music.vue
// module id = 185
// module chunks = 12